import { render, staticRenderFns } from "./SimProducts.vue?vue&type=template&id=059f1b6a&scoped=true&"
import script from "./SimProducts.vue?vue&type=script&lang=ts&"
export * from "./SimProducts.vue?vue&type=script&lang=ts&"
import style0 from "./SimProducts.vue?vue&type=style&index=0&id=059f1b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f1b6a",
  null
  
)

export default component.exports